import { h } from "preact"

export default function Card({ title, children }) {
    return (
        <>
            {title && (
                <header className="container-fluid shadow-sm py-2">
                    <h2 className="h1 m-0">{title}</h2>
                </header>
            )}
            <main className="container-fluid py-3">{children}</main>
        </>
    )
}
